import React from 'react';
import PropTypes from 'prop-types';
import { Container, Text } from './styles';

const Badge = ({ value, bgColor, txtColor, txtFontWeight }) => (
  <Container bgColor={bgColor}>
    <Text txtColor={txtColor} txtFontWeight={txtFontWeight}>{value}</Text>
  </Container>
);

Badge.defaultProps = {
  bgColor: '#666666',
  txtColor: 'white',
  txtFontWeight: 'normal',
};


Badge.propTypes = {
  value: PropTypes.string.isRequired,
  bgColor: PropTypes.string,
  txtColor: PropTypes.string,
  txtFontWeight: PropTypes.string,
};

export default Badge;
